module.exports = __webpack_public_path__ + "img/contentsClipIcon.6f21dcae.svg";